import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class MuviUltimate extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            contactus: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            activePage: 1,
            item_count: '',
            message: '',
            fromdate: '',
            todate: '',
            from_date: '',
            to_date: '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            search: '',
            isLoadMore: 1,
            loading: 1,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.formdateChange = this.formdateChange.bind(this);
        this.getSourceLink = this.getSourceLink.bind(this);
        this.todateChange = this.todateChange.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    formdateChange(event) {
        this.setState({
            fromdate: event,
            from_date: moment(event).format("YYYY-MM-D"),
            activePage: 1
        }, function () {
            this.contactList();
        });
    }
    todateChange(event) {
        this.setState({
            todate: event,
            to_date: moment(event).format("YYYY-MM-D"),
            activePage: 1
        }, function () {
            this.contactList();
        });
    }

    getSourceLink(link)
    {
        if(link){
            if(link.indexOf('http') !== -1)
            {
                var linknew = <a href={`${link}`}>{`${link}`}</a>;
                return linknew
            }
            else
            {return link}
        }   else {
            return 'NA';
        }   
    }

    keywordChange(event) {
        var obj = this;
        this.setState({ search: event.target.value,activePage: 1});
        if (this.timer) {
            window.clearTimeout(this.timer);
    }
        this.timer = window.setTimeout(function () {
            obj.contactList();
        }, 500);
    }
    back() {
        window.location.href = '/MuviUltimate';
    }

    handlePageChange(pageNumber = 1) {
        var totalPages =  (this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/AdvancedRest/MuviUltimate/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        contactus: findresponse.contactus,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    contactList(page = 1) {
        fetch(this.state.apiUrl + '/AdvancedRest/MuviUltimate/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    loading: 0,
                    contactus: findresponse.contactus,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }

    export() {
        var win = window.open(this.state.apiUrl + "/MuviUltimate/ExportAdvanced/userAuthKey/" + this.state.userAuthKey + "/type/contactus/fromdate/" + this.state.from_date + "/todate/" + this.state.to_date + "/search/" + this.state.search, '_self');
        win.focus()
    }

    componentDidMount() {
        document.title = "Intranet | Muvi Ultimate";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.contactList();
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function () {
                //ticketsList();
                // window.location.reload();
            }, 10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function () {
                $(this).closest('.intranet_body').find('.form-section').slideToggle('slow');
            });
        });
    }
    getCustomerDetails() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        } else {
            console.log(this.state.contactus);
            return (
                <div class="list_check">
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head adv">
                            <li class="intra_col_10">Name</li>
                            <li class="intra_col_15">Email</li>
                            <li class="intra_col_10">Company</li>
                            <li class="intra_col_10">Phone No</li>
                            <li class="intra_col_10">Requirement</li>
                            <li class="intra_col_10">IPAddress</li>
                            <li class="intra_col_10">Source</li>
                            <li class="intra_col_15">Extranet Source</li>
                            <li class="intra_col_10">Date</li>
                        </ul>
                        {
                            
                            this.state.contactus.map((contact, key) =>
                            
                                <ul class="tickets_number" >
                                    <li class="intra_col_10"> {contact.full_name}</li>
                                    <li class="intra_col_15"><a href={"mailto:" + contact.business_email} alt="Email">{contact.business_email}</a></li>
                                    <li class="intra_col_10"> {contact.company_name}</li>
                                    <li class="intra_col_10">{contact.business_phone_number}</li>                                  
                                    <li class="intra_col_10">{contact.requirement}</li>  

                                    <li class="intra_col_10">
                                        {contact.ip_address}
                                        {/* {this.getSourceLink(contact.source)} */}
                                    </li> 
                                    <li class="intra_col_10 text-inded">{this.getSourceLink(contact.source)}
                                    </li> 
                                    <li class="intra_col_15 text-inded">{this.getSourceLink(contact.extranet_source)}</li>                         
                                    <li class="intra_col_10">{contact.created_date}</li>
                                </ul>

                            )
                        }
                    </div>
                    <div class="tickets_mob hidden-md">
                        {
                            this.state.contactus.map((contact, key) =>

                                <div class="list_mob">
                                    {/* <span onClick={()=> this.goToTicketDetails(todo.id,todo.assigned_to,todo.owner_name)}> */}
                                    <h4 class="list_title">{contact.name}</h4>
                                    <div class="section word-break">
                                        <div class="wrap pull-left">
                                            <span class="">{contact.company}</span>
                                        </div>
                                        <div class="wrap pull-right">

                                        </div>
                                    </div>
                                    <div class="section gry">
                                        <div class="wrap">
                                            <span>{contact.created_date}</span>
                                        </div>
                                    </div>
                                    {/* </span> */}
                                </div>

                            )
                        }
                    </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}

                </div>
            )
        }
    }

     handleApply = (event, picker) => {
        picker.element.val(
          picker.startDate.format('DD/MM/YYYY') +
            ' - ' +
            picker.endDate.format('DD/MM/YYYY')
        );
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-D'),
            to_date: picker.endDate.format('YYYY-MM-D')
        }, () => {
            this.contactList()
        })
    };


    applyHandler = (event, picker) =>
    {
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-D'),
            to_date: picker.endDate.format('YYYY-MM-D')
        }, () => {
            this.contactList()
        })
    }
    
    handleCallback( start, end, label ){

        console.log(start, end, label);
    }

    handleEvent = (event, picker) =>{
        this.setState({
          inputStart: picker.startDate.format('YYYY/MM/D'),
          inputFinish: picker.endDate.format('YYYY/MM/D')
        });
      }

      onCancel = (event, picker) => {

        this.setState({

            from_date: '',
            to_date: ''
        }, () => {

            this.contactList();
            picker.element.val(
                'From Date - To Date'
              );


        })
  }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Muvi Ultimate" brecum_page="Muvi Ultimate" />
                <div class="right_col">

                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            <span>Muvi Ultimate</span>
                            <div class="mob-search hidden-md pull-right">
                                <i class="fa fa-search"></i>
                                <i class="fa fa-sliders" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="top-row">
                            <div class="row">
                                <div class="form-group col-sm-4 col-xs-4 icon-calender">
                                            <div class="filter">
                                            <DateRangePicker 
                                             initialSettings={{
                                                showDropdowns: true,
                                                
                                                autoUpdateInput: false,
                                                linkedCalendars:false,
                                                locale: {
                                                    cancelLabel: 'Clear',
                                                },

                                            }}
    
                                            onCallback={this.handleCallback}
                                            onApply={this.handleApply}
                                            onEvent={this.handleEvent}
                                            onCancel={this.onCancel}
                                            >
                                                <input className="form-control" defaultValue="" placeholder="From Date - To Date"/>
                                            </DateRangePicker>
                                            </div>
                                            <i class="fal fa-calendar-alt"></i>
                                        </div>
                                
                                    <div class="col-sm-6 col-xs-6 float-right" style={ {float: 'right'} }>
                                        <div class="searchTicket mob_100">
                                            <input type="text" class="form-control" name="customer" id="customer" placeholder="Search by name, email or company" onChange={this.keywordChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>

                                </div>
                            </div>
                        </div>
                        {this.getCustomerDetails()}
                    </div>
                </div>
            </div>
        )
    }
}
export default MuviUltimate


// WEBPACK FOOTER //
// ./src/components/advanced/MuviUltimate.js